import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Pages
import DashboardPage from './pages/DashboardPage';
import InventairePage from './pages/InventairePage.simple';
import LieuxPage from './pages/LieuxPage';
import ProfilPage from './pages/ProfilPage';
import LoginPage from './pages/LoginPage';
import LoginOAuthCallbackPage from './pages/LoginOAuthCallbackPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import SelectOrganizationPage from './pages/SelectOrganizationPage';
import SsoAccessDeniedPage from './pages/SsoAccessDeniedPage';

// Components
import Navigation from './components/Navigation';
import MobileLayoutOptimized from './components/MobileLayoutOptimized';
import MobileNavigation from './components/MobileNavigation';
import RequireSession from './components/RequireSession';
import { PhotoViewerProvider } from './contexts/PhotoViewerContext';
import { ToastProvider } from './contexts/ToastContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 3,
    },
  },
});

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
      <PhotoViewerProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/login/oauth-callback" element={<LoginOAuthCallbackPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route path="/auth/select-organization" element={<SelectOrganizationPage />} />
          <Route path="/auth/access-denied" element={<SsoAccessDeniedPage />} />
          <Route path="/*" element={
            <RequireSession>
              {(user, handleLogout) => (
              <MobileLayoutOptimized>
                <div className="md:hidden">
                  <MobileNavigation />
                </div>
                <div className="hidden md:block">
                  <Navigation onLogout={handleLogout} user={user} />
                </div>
                <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                  <Routes>
                    <Route path="/" element={<DashboardPage />} />
                    <Route path="/inventaire" element={<InventairePage />} />
                    <Route path="/lieux" element={<LieuxPage />} />
                    <Route path="/profil" element={<ProfilPage />} />
                  </Routes>
                </main>
              </MobileLayoutOptimized>
              )}
            </RequireSession>
          } />
        </Routes>
      </Router>
      </PhotoViewerProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
};

export default App;